import { dtoCtor, Dto } from '../helper';
import { AreaContent } from './areaContent';

class Area implements Dto {
  dtoName?: string;

  constructor(props?: Omit<Area, 'dtoName'>) {
    dtoCtor(this, 'Area', props);
  }

  key?: string;
  areaContent?: AreaContent;
}

export { Area };
